module.exports = __webpack_public_path__ + "img/Avatar.890828c0.svg";